import * as Api from '@ViewModels';

type TGuestOptionStep = 'email' | 'addTag' | 'removeTag';

interface IGuestOptionCopy {
	title: string;
	description: string;
}

const meetingCopy: Record<TGuestOptionStep, IGuestOptionCopy> = {
	email: {
		title: 'CC meeting guests',
		description:
			'Guests added to the booking are copied on this email and see the same message as the person who booked.',
	},
	addTag: {
		title: 'Also tag meeting guests',
		description:
			'Guests added to the booking get this tag too, so automations that key off it treat them like the person who booked.',
	},
	removeTag: {
		title: 'Also remove from meeting guests',
		description: 'This tag is removed from guests added to the booking as well.',
	},
};

const eventCopy: Record<TGuestOptionStep, IGuestOptionCopy> = {
	email: {
		title: 'CC event guests',
		description:
			'Guests who provided an email when registering are copied on this email and see the same message as the person who registered.',
	},
	addTag: {
		title: 'Also tag event guests',
		description: 'Guests who provided an email when registering get this tag too.',
	},
	removeTag: {
		title: 'Also remove from event guests',
		description: 'This tag is removed from the registration’s guests as well.',
	},
};

/** The guest option's wording for this trigger, or null when the trigger has no guests to reach. */
export const getStepGuestOptionCopy = (
	trigger: Api.IAutomationTrigger | null | undefined,
	step: TGuestOptionStep
): IGuestOptionCopy | null => {
	switch (trigger?._type) {
		case Api.AutomationTriggerType.Meeting:
			return meetingCopy[step];
		case Api.AutomationTriggerType.EventRegistration:
			return eventCopy[step];
		default:
			return null;
	}
};
